<template>
  <el-dialog title="表格展示数据项" :visible.sync="columnsDialogConfig.visible" width="50%">
    <el-form ref="form" :model="columnsDialogConfig.form" label-width="100px" :inline="false">
      <el-form-item v-for="item in columnsDialogConfig.formList" :key="item.id" :label="item.label">
        <el-row>
          <el-checkbox-group v-model="columnsDialogConfig.form[item.prop]">
            <el-col :span="8" v-for="optItem in item.list" :key="optItem.prop">
              <el-checkbox
                :label="optItem.prop"
                :disabled="optItem.disabled ? optItem.disabled : false"
                @change="handleCheckBox"
                :checked="optItem.checked ? optItem.checked : false"
              >{{optItem.label}}</el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-row>
      </el-form-item>
    </el-form>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
      <el-button @click="columnsDialogConfig.visible = false">取 消</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { deepClone } from "@/util/userUtil"
export default {
  props: {
    columnsDialogConfig: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    tableColumns: {
      type: Array,
      // required: true,
      default: () => {
        return []
      }
    }
  },
  methods: {
    // handleConfirm() {
    //   this.$emit("handleConfirm")
    // },
    handleCheckBox() {
      let tableColumns = deepClone(this.tableColumns)
      const contactForm = [].concat(this.columnsDialogConfig.form.mustColumns, this.columnsDialogConfig.form.optionalColumns)
      // const mustColumns = this.columnsDialogConfig.form.mustColumns
      const optionalColumns = this.columnsDialogConfig.form.optionalColumns
      // 先删除掉与选中form中不相同的
      tableColumns.forEach((v, i) => {
        let flag = true
        contactForm.forEach(j => {
          if(v.prop === j) {
            flag = false
            return
          }
        })
        if(flag) tableColumns.splice(i, 1)
      })
      // 再添加columns中没有的
      let arr = []
      contactForm.forEach(v => {
        let flag = true
        tableColumns.forEach(j => {
          if(v === j.prop) {
            flag = false
            return
          }
        })
        if(flag) {
          this.columnsDialogConfig.formList[1].list.forEach(k => {
            if(k.prop === v) arr.push(k)
          })
        }
      })
      // 最后将arr添加到taleColumns中
      tableColumns = tableColumns.concat(arr)
      this.$emit('handleCheckBox', tableColumns)
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-button + .el-button {
  margin-left: 10px;
}
</style>